import React from 'react';

class NiceicDownloadButton extends React.PureComponent {
  render() {
    const { handleDownload, isDisabled } = this.props;
    return (
      <button
        className="pocket-guides__download-btn"
        disabled={isDisabled}
        onClick={handleDownload}
      >
        Download Pocket Guides
      </button>
    );
  }
}

export default NiceicDownloadButton;
